<template>
  <span>
    <label class="page-label">{{ $t('message.pages.live.liveThumbnail') }}</label>
    <p style="font-weight: 400px; font-size: 14px; line-height: 21px;">{{
      $t('message.pages.live.liveThumbnailDescription') }}</p>

    <v-skeleton-loader v-if="loading" type="image" height="190px" width="100%"
      style="margin-top: 4px"></v-skeleton-loader>
    <!-- Add the file input for live thumbnail -->
    <v-file-input v-if="!hasThumbnail && !loading" v-model="newThumbnail.file" class="new-live-cover"
      :prepend-icon="loading ? '' : 'mdi-upload'" accept="image/png, image/jpeg, image/gif" hide-input
      @change="handleChangeThumbnail">
      <v-progress-circular v-if="loading && hasThumbnail" :size="22" width="3" color="primary" indeterminate
        style="z-index: 999;"></v-progress-circular>
    </v-file-input>



    <v-card v-if="hasThumbnail && !loading" class="mr-4 mt-5 d-flex align-center justify-center flex-column"
      style="width: 100%;">
      <div class="thumbnail-container" @mouseover="showDeleteIcon = true" @mouseleave="showDeleteIcon = false">
        <img :key="defaultThumbnail" class="defaultThumb" :src="defaultThumbnail" @error="imageError = true" />
        <v-icon v-show="showDeleteIcon" class="delete-icon" @click="hasThumbnail = false">
          mdi-close
        </v-icon>
      </div>
    </v-card>
  </span>
</template>

<script>
import { mapMutations } from 'vuex'
import videosApi from '@/services/videosApi'
import liveService from '@/services/liveServiceV2'
import { THUMB_URL } from '@/config/envs'
//import i18n from '@/translations/lang'

export default {
  name: 'LiveCover',
  data: () => ({
    liveInfo: {},
    showGraph: false,
    streamDetails: {},
    isBeta: false,
    viewMetrics: {},
    hasThumbnail: false,
    title: '',
    streamKey: '',
    hostId: '',
    streamUrl: '',
    defaultThumbnail: null,
    serverStatus: 'offline',
    livePlayer: '',
    restreamDialog: false,
    showCDN: false,
    imageError: false,
    liveEnded: false,
    loading: false,
    scheduled: null,
    liveStatus: '',
    showLiveTitle: false,
    reStreamError: null,
    saveLoading: false,
    cancelLoading: false,
    addRestreamLoading: false,
    reStreamLoading: false,
    streamHls: '',
    successfulChangedThumb: false,
    errors: {
      addThumbnail: false,
      wrongThumbnailFile: false,
      liveFetch: false,
      updateTitleError: false,
      initNow: null,
      viewers: false,
      liveEnd: false,
    },
    loadings: {
      newThumbnail: false,
      initNow: false,
      endLive: false,
    },
    newRestream: {
      rtmp: '',
      streamKey: '',
    },
    newThumbnail: {
      file: null,
    },
    restreams: [],
    checkViewers: null,
    viewers: 0,
    scheduled_at: '',
    lastVerificationServer: '',
    dDisplay: '',
    showDeleteIcon: true,
    value: '',
    attrs: '',
    on: '',
    liveBytesIn: 0,
    previousBytes: null,
    previousTime: null,
    liveKbps: null,
  }),
  computed: {
    hasEditVideoPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-video') ?? false
      )
    },
  },
  watch: {
    defaultThumbnail(val) {
      if (!val || val.indexOf('date') === -1) {
        this.loadDefaultThumbnail()
      }
    },
  },
  mounted() {
    this.streamUrl = this.$root.streamUrl
    this.streamHls = this.$root.streamHls
    this.streamKey = this.$root.streamKey
    this.fetchData()
  },
  created() {
    this.fetchData()
    this.loadDefaultThumbnail()
  },

  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),

    async fetchData() {
      this.loading = true
      try {
        const response = await liveService.getLive(this.$route.params.id)
        this.errors.liveFetch = false
        this.liveInfo = response.data
        this.$root.liveStatus = response.data.status


        this.streamUrl = response.data.rtmp
        this.streamHls = response.data.live_hls
        this.livePlayer = response.data.live_player
        this.viewMetrics = response.data.view_metrics
        this.videoId = response.data.video_id
        this.serverStatus = response.data.host_status
        this.liveStatus = response.data.status


        if (response.data.config.thumbnail) {
          this.defaultThumbnail = response.data.config.thumbnail
          this.loadDefaultThumbnail()
          this.hasThumbnail = true

        }
      } catch (error) {

        this.errors.videoDoesNotExist = true
        this.errors.liveFetch = true
      }
      this.loading = false
    },

    clearErrors() {
      Object.keys(this.errors).forEach((e) => (this.errors[e] = false))
    },

    async handleChangeThumbnail() {
      this.successfulChangedThumb = false
      this.clearErrors()
      const file = this.newThumbnail.file
      let fileExtension =
        file?.name?.substring(
          file?.name?.lastIndexOf('.') + 1,
          file?.name?.length
        ) || file?.name

      if (
        fileExtension !== 'jpg' &&
        fileExtension !== 'png' &&
        fileExtension !== 'jpeg'
      ) {
        this.errors.wrongThumbnailFile = true
        this.newThumbnail.file = null
        return
      }

      this.loading = true

      const data = new FormData()
      data.append('file', file)
      let str = this.livePlayer
      let LIBRARY_ID = str
        .split('//')
        .pop()
        .split('.')[0]
        .replace('player-', '')
      const date = new Date().getTime()

      try {
        const ret = await videosApi.addThumbnailToVideo(
          this.$route.params.id + '?type=live',
          data
        )

        this.loadDefaultThumbnail()
        this.hasThumbnail = true

        this.imageError = false
        this.defaultThumbnail = `${THUMB_URL}/${LIBRARY_ID}/${ret.data.response.thumbnail}?date=${date}`
        this.successfulChangedThumb = true
        this.$forceUpdate()
        return ret
      } catch (e) {
        this.errors.addThumbnail = true
      } finally {
        this.loading = false
      }
    },



    async deleteThumbnail() {
      this.loadings.newThumbnail = true
      try {
        const ret = await videosApi.deleteThumbnailVideo(
          this.$route.params.id + '?type=live'
        )
        this.loadings.newThumbnail = false
        this.defaultThumbnail = null
        this.hasThumbnail = false
        return ret
      } catch (e) {
        this.loadings.newThumbnail = false
        this.errors.addThumbnail = true
      }
    },


    async loadDefaultThumbnail() {

      if (this.defaultThumbnail) {

        let LIBRARY_ID = this.liveInfo.live_player
          .split('//')
          .pop()
          .split('.')[0]
          .replace('player-', '')

        this.defaultThumbnail = `${THUMB_URL}/${LIBRARY_ID}/${this.liveInfo.config.thumbnail
          }?date=${new Date().getTime()}`
      }
    },


  },
}
</script>

<style lang="scss" scoped>
.new-live-cover {
  display: flex;
  height: 190px;
  border-radius: 4px;
  background: var(--v-neutral-lighten3);

  align-items: center;
  justify-content: center;

  &::v-deep {
    .v-icon {
      color: var(--v-brand-base);
    }
  }
}

.defaultThumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.changeText {
  font-size: 14px;
  font-weight: 500;
  color: #3F55EE;
  cursor: pointer;
}

.delete-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  color: white;
  font-size: 24px;
}

.thumbnail-container {
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 190px;
  position: relative;
  overflow: hidden;
  border-radius: 4px;
}



.bg-dark {
  .page-label {
    color: var(--v-primary-base) !important;
  }
}
</style>